module.exports = __webpack_public_path__ + "img/trust_logo.33d04e50.svg";